"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsGroup = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("../CheckBox/Button");
require("./index.scss");
const className = 'options-group';
const OptionsGroup = (props) => {
    const { options, select } = props;
    const selectedIds = (typeof props.selectedIds === 'object'
        ? props.selectedIds
        : [props.selectedIds]);
    return (react_1.default.createElement("div", { className: className }, options.map((option, i) => {
        const checkBoxButtonProps = {
            name: typeof option.id === 'number' ? `${option.id}` : option.id,
            text: typeof option.label === 'number' ? `${option.label}` : option.label,
            onChange: () => select(option.id),
            checked: selectedIds.filter(x => x === option.id).length === 1,
            additionClassName: `${className}__option`,
            additionTextClassName: `${className}__option-text`,
        };
        return (react_1.default.createElement(Button_1.CheckBoxButton, { ...checkBoxButtonProps, key: i }));
    })));
};
exports.OptionsGroup = OptionsGroup;
//# sourceMappingURL=index.js.map